import { schema } from 'normalizr';

export const deferredCharge = new schema.Entity('deferredCharges');
export const deferredCharges = [deferredCharge];
